import type { Filter, FilterDataOption, FilterDataMultiSelect } from '@/app/common/filters/core/filtersTypes.ts';
import { FILTER_TYPE } from '@/app/common/filters/core/filtersTypes.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import { isBeachHoliday } from '@/app/common/filters/groups/isBeachHoliday.ts';
import { type TranslationDictionary } from '@/app/components/translations/createTranslationDictionary.ts';
import { FILTER_NAME } from '@/app/common/filters/core/filterNames.ts';
import type { SimpleOptionCreate } from '@/app/common/filters/groups/filterGroupsUtils.ts';
import { simpleOptionCreator } from '@/app/common/filters/groups/filterGroupsUtils.ts';

const CLIMATE_DEFAULT_VALUE = '0';

const createClimateOptions = (simpleOptionCreate: SimpleOptionCreate): FilterDataOption[] => [
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.climate.all', value: CLIMATE_DEFAULT_VALUE }),
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.climate.tropical', value: '1' }),
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.climate.subtropical', value: '2' }),
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.climate.equatorial', value: '3' }),
  simpleOptionCreate({ labelKey: 'vacation.oss.filters.climate.subequatorial', value: '4' }),
];

type CreateClimateFilters = {
  searchParams: SearchParams;
  translationDictionary: TranslationDictionary;
};
export const createClimateFilters = ({ searchParams, translationDictionary }: CreateClimateFilters): Filter[] => {
  const showClimateFilter = isBeachHoliday(searchParams);
  const selectedValuesFromUrl = searchParams[URLParameters.CLIMATE]?.split(',') || [];
  const selectedValues = selectedValuesFromUrl.length > 0 ? selectedValuesFromUrl : [CLIMATE_DEFAULT_VALUE];

  const simpleOptionCreate = simpleOptionCreator({ selectedValues, translationDictionary });

  const climateTypeFilter: Filter | undefined = showClimateFilter
    ? {
        name: FILTER_NAME.CLIMATE,
        type: FILTER_TYPE.MULTI_SELECT,
        data: {
          options: createClimateOptions(simpleOptionCreate),
        } as FilterDataMultiSelect,
      }
    : undefined;

  return [...[climateTypeFilter]].filter((f) => !!f);
};
